<template>
    <div class="process" :style="{border: `1px solid ${borderMap[this.type]}`}">
        <div class="dda blue-d" v-if="type==='blue'" :style="{width: this.value+'%'}"></div>
        <div class="dda green-d" v-if="type==='green'" :style="{width: this.value+'%'}"></div>
        <div class="dda red-d" v-if="type==='red'" :style="{width: this.value+'%'}"></div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Number
        },
        type: {
            type: String,
            default: "blue"
        }
    },
    data() {
        return {
            borderMap:{
                "blue": "#00EDF3",
                "red": "#FF0037",
                "green": "#C7DD3E"
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.process {
    width: 2rem;
    height: 0.5625rem;
    border-radius: 0.3125rem;
    border: 1px solid #00EDF3;
    position: relative;
    overflow: hidden;
    .dda {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
    }
    .blue-d {
        background-image: linear-gradient(90deg, #3FC1FF 13%, #3FC1FF 56%, rgba(63,193,255,0.26) 100%);
    }
    .green-d {
        background-image: linear-gradient(90deg, #C6DD3E 18%, rgba(173,249,169,0.62) 100%);
    }
    .red-d {
        background-image: linear-gradient(106deg, #FF0037 5%, rgba(255,115,87,0.81) 100%);
    }
}
</style>